import React from 'react'

import styled from 'styled-components/native'

import { MessagingIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/MessagingIcon'
import { TertiaryIconButton } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/tertiaryIconButton/TertiaryIconButton'

import useChatPopout from '../../../../messages/hooks/useChatPopout'

type ClientListActionsProps = {
  clientId: string
}

const MessagingButton = styled(TertiaryIconButton)({
  alignSelf: 'center',
})

const ClientListActions: React.FC<ClientListActionsProps> = ({ clientId }) => {
  const { onOpenNewWindow } = useChatPopout(clientId)
  return <MessagingButton leftIcon={<MessagingIcon />} onPress={onOpenNewWindow} />
}

export default ClientListActions
